<template>
  <div
    :class="{
      'cabinet-sidebar': true,
      'cabinet-sidebar--condensed': props.condensed,
    }"
  >
    <div class="cabinet-sidebar__header" v-if="slots.header">
      <slot name="header" />
    </div>
    <div class="cabinet-sidebar__content" v-if="slots.default">
      <slot name="default" />
    </div>
    <div class="cabinet-sidebar__footer" v-if="slots.footer">
      <slot name="footer" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useSlots } from 'vue'
interface Props {
  condensed: boolean
}
const props = defineProps<Props>()
const slots = useSlots()
</script>
